import { jsxs as u, jsx as t, Fragment as be } from "react/jsx-runtime";
import { createContext as ee, useContext as _, forwardRef as h, useState as j, useCallback as V, useMemo as ae, useId as ne, useEffect as Y, useRef as D, Fragment as ve } from "react";
import { ChevronDown as re, X as se, Info as ye, AlertTriangle as Ne, CheckCircle2 as we, XCircle as Te, ChevronRight as oe, ArrowDownToLine as Se, ArrowUpFromLine as $e, Bell as ke, Copy as xe, FileText as Ce, LayoutDashboard as Be, LifeBuoy as Ie, LogOut as Le, Network as Ae, Settings as Oe, ShieldCheck as Fe, Star as We, TrendingUp as Pe, Trophy as Ee, UserCircle as Me, Users as Re, Wallet as Ue } from "lucide-react";
import { createPortal as Ge } from "react-dom";
function d(...l) {
  const e = [];
  for (const n of l)
    if (!(!n && n !== 0))
      if (Array.isArray(n)) {
        const a = d(...n);
        a && e.push(a);
      } else
        e.push(String(n));
  return e.join(" ");
}
const ce = ee(null);
function ie() {
  return _(ce) ?? {
    sidebarOpen: !1,
    openSidebar: Z,
    closeSidebar: Z,
    toggleSidebar: Z
  };
}
function Z() {
}
const ze = "alpha-layout-XmWu9", qe = "alpha-main-W6r00", De = "alpha-content-gqfyF", je = "alpha-overlay-aAYAo", Ye = "alpha-overlayActive-IqgIk", He = "alpha-impersonation--66H7", H = {
  layout: ze,
  main: qe,
  content: De,
  overlay: je,
  overlayActive: Ye,
  impersonation: He
}, Ft = h(function({
  sidebar: e,
  topbar: n,
  impersonationBanner: a,
  children: r,
  sidebarOpen: s,
  onSidebarOpenChange: o,
  className: c,
  contentClassName: i,
  ...p
}, g) {
  const [N, w] = j(!1), y = s !== void 0, m = y ? s : N, T = V(
    (B) => {
      y || w(B), o == null || o(B);
    },
    [y, o]
  ), b = ae(
    () => ({
      sidebarOpen: m,
      openSidebar: () => T(!0),
      closeSidebar: () => T(!1),
      toggleSidebar: () => T(!m)
    }),
    [m, T]
  );
  return /* @__PURE__ */ u(ce.Provider, { value: b, children: [
    /* @__PURE__ */ u("div", { ref: g, className: d(H.layout, c), ...p, children: [
      e,
      /* @__PURE__ */ u("div", { className: H.main, children: [
        n,
        a ? /* @__PURE__ */ t("div", { className: H.impersonation, children: a }) : null,
        /* @__PURE__ */ t("div", { className: d(H.content, i), children: r })
      ] })
    ] }),
    /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        "aria-label": "Close navigation",
        tabIndex: m ? 0 : -1,
        className: d(H.overlay, m && H.overlayActive),
        onClick: () => T(!1)
      }
    )
  ] });
}), Xe = "alpha-sidebar-UB1qz", Ke = "alpha-logo-11IqO", Ve = "alpha-logoText-w0Izg", Qe = "alpha-user-wlwoC", Ze = "alpha-userAvatar-YXJtW", Je = "alpha-userBody-kjWVc", _e = "alpha-userName-eLEJt", ea = "alpha-userId-omWD6", aa = "alpha-nav-aLYuL", na = "alpha-footer-TyRyi", ta = "alpha-group-YRfYm", la = "alpha-groupHeader-MO-RO", ra = "alpha-groupOpen-xCxbS", sa = "alpha-groupLabel-StYOt", oa = "alpha-chevron-ZW-u9", ca = "alpha-groupBody-6EWX-", ia = "alpha-link-xL3Wh", da = "alpha-linkActive-nUuyn", ua = "alpha-linkFlush-kCXRN", pa = "alpha-icon-UQswn", ha = "alpha-linkLabel-o-u3y", ma = "alpha-linkBadge-wuHQU", fa = "alpha-sidebarOpen-Gfgrx", S = {
  sidebar: Xe,
  logo: Ke,
  logoText: Ve,
  user: Qe,
  userAvatar: Ze,
  userBody: Je,
  userName: _e,
  userId: ea,
  nav: aa,
  footer: na,
  group: ta,
  groupHeader: la,
  groupOpen: ra,
  groupLabel: sa,
  chevron: oa,
  groupBody: ca,
  link: ia,
  linkActive: da,
  linkFlush: ua,
  icon: pa,
  linkLabel: ha,
  linkBadge: ma,
  sidebarOpen: fa
}, Wt = h(function({ logo: e, user: n, children: a, footer: r, open: s, className: o, ...c }, i) {
  const { sidebarOpen: p } = ie(), g = s ?? p;
  return /* @__PURE__ */ u("aside", { ref: i, className: d(S.sidebar, g && S.sidebarOpen, o), ...c, children: [
    e ? /* @__PURE__ */ t("div", { className: S.logo, children: e }) : null,
    n,
    a,
    r ? /* @__PURE__ */ t("div", { className: S.footer, children: r }) : null
  ] });
}), Pt = h(function({ src: e, alt: n = "", title: a, className: r, ...s }, o) {
  return /* @__PURE__ */ u("div", { ref: o, className: r, ...s, style: { display: "flex", alignItems: "center", gap: 10 }, children: [
    e ? /* @__PURE__ */ t("img", { src: e, alt: n, height: 36 }) : null,
    /* @__PURE__ */ t("span", { className: S.logoText, children: a })
  ] });
}), Et = h(function({ name: e, userId: n, avatar: a, className: r, ...s }, o) {
  return /* @__PURE__ */ u("div", { ref: o, className: d(S.user, r), ...s, children: [
    a ? /* @__PURE__ */ t("span", { className: S.userAvatar, children: a }) : null,
    /* @__PURE__ */ u("div", { className: S.userBody, children: [
      /* @__PURE__ */ t("div", { className: S.userName, children: e }),
      n ? /* @__PURE__ */ t("div", { className: S.userId, children: n }) : null
    ] })
  ] });
}), de = ee({}), ue = ee(null), Mt = h(function({ children: e, currentPath: n, linkComponent: a, onNavigate: r, className: s, ...o }, c) {
  const i = ae(
    () => ({ currentPath: n, linkComponent: a, onNavigate: r }),
    [n, a, r]
  );
  return /* @__PURE__ */ t(de.Provider, { value: i, children: /* @__PURE__ */ t("nav", { ref: c, className: d(S.nav, s), ...o, children: e }) });
});
function pe(l) {
  return "nav_" + l.replace(/\W/g, "_");
}
function ga(l) {
  if (!(typeof window > "u"))
    try {
      const e = window.sessionStorage.getItem(pe(l));
      if (e === "1") return !0;
      if (e === "0") return !1;
    } catch {
    }
}
function ba(l, e) {
  if (!(typeof window > "u"))
    try {
      window.sessionStorage.setItem(pe(l), e ? "1" : "0");
    } catch {
    }
}
const Rt = h(function({ label: e, icon: n, defaultOpen: a = !1, forceOpen: r = !1, children: s, className: o, ...c }, i) {
  const [p, g] = j([]), N = r || p.length > 0, [w, y] = j(() => ga(e) ?? a), m = ne(), T = w;
  Y(() => {
    N && y(!0);
  }, [N]);
  const b = V((L, O) => {
    g((R) => {
      const f = R.includes(L);
      return O === f ? R : O ? [...R, L] : R.filter((v) => v !== L);
    });
  }, []), B = V((L) => {
    g((O) => O.includes(L) ? O.filter((R) => R !== L) : O);
  }, []), $ = ae(() => ({ registerActive: b, unregister: B }), [b, B]), C = () => {
    const L = !T;
    y(L), ba(e, L);
  };
  return /* @__PURE__ */ t(ue.Provider, { value: $, children: /* @__PURE__ */ u("div", { ref: i, className: d(S.group, T && S.groupOpen, o), ...c, children: [
    /* @__PURE__ */ u(
      "button",
      {
        type: "button",
        className: S.groupHeader,
        "aria-expanded": T,
        "aria-controls": m,
        onClick: C,
        children: [
          /* @__PURE__ */ u("span", { className: S.groupLabel, children: [
            n ? /* @__PURE__ */ t("span", { className: S.icon, children: n }) : null,
            /* @__PURE__ */ t("span", { children: e })
          ] }),
          /* @__PURE__ */ t(re, { className: S.chevron, size: 14, "aria-hidden": !0 })
        ]
      }
    ),
    /* @__PURE__ */ t("div", { id: m, className: S.groupBody, children: s })
  ] }) });
});
function Ut({
  href: l,
  children: e,
  icon: n,
  badge: a,
  active: r,
  match: s = "exact",
  flush: o = !1,
  className: c,
  onClick: i
}) {
  const { currentPath: p, linkComponent: g, onNavigate: N } = _(de), w = _(ue), y = ne(), m = r ?? (p === void 0 ? !1 : s === "exact" ? p === l : p === l || p.startsWith(l.endsWith("/") ? l : l + "/")), T = D(w);
  T.current = w, Y(() => {
    var $;
    return ($ = T.current) == null || $.registerActive(y, m), () => {
      var C;
      return (C = T.current) == null ? void 0 : C.unregister(y);
    };
  }, [y, m]);
  const b = g ?? "a";
  return /* @__PURE__ */ u(
    b,
    {
      ...b === "a" ? { href: l } : { to: l, end: s === "exact" },
      className: d(S.link, o && S.linkFlush, m && S.linkActive, c),
      "aria-current": m ? "page" : void 0,
      onClick: ($) => {
        i == null || i($), N == null || N();
      },
      children: [
        n ? /* @__PURE__ */ t("span", { className: S.icon, children: n }) : null,
        /* @__PURE__ */ t("span", { className: S.linkLabel, children: e }),
        a ? /* @__PURE__ */ t("span", { className: S.linkBadge, children: a }) : null
      ]
    }
  );
}
const va = "alpha-topbar-9LX5L", ya = "alpha-left-FPDbB", Na = "alpha-title-l4Oor", wa = "alpha-actions-1cI4x", Ta = "alpha-balance-YNtOK", Sa = "alpha-balanceIncome-Prlfk", $a = "alpha-balanceLabel-kV1fI", ka = "alpha-hamburger-L3fqE", M = {
  topbar: va,
  left: ya,
  title: Na,
  actions: wa,
  balance: Ta,
  balanceIncome: Sa,
  balanceLabel: $a,
  hamburger: ka
}, Gt = h(function({ title: e, actions: n, hideHamburger: a = !1, className: r, children: s, ...o }, c) {
  const { toggleSidebar: i } = ie();
  return /* @__PURE__ */ u("div", { ref: c, className: d(M.topbar, r), ...o, children: [
    /* @__PURE__ */ u("div", { className: M.left, children: [
      a ? null : /* @__PURE__ */ t(xa, { onClick: i }),
      e ? /* @__PURE__ */ t("div", { className: M.title, children: e }) : null,
      s
    ] }),
    n ? /* @__PURE__ */ t("div", { className: M.actions, children: n }) : null
  ] });
}), xa = h(function({ className: e, ...n }, a) {
  return /* @__PURE__ */ u("button", { ref: a, type: "button", "aria-label": "Toggle navigation", className: d(M.hamburger, e), ...n, children: [
    /* @__PURE__ */ t("span", {}),
    /* @__PURE__ */ t("span", {}),
    /* @__PURE__ */ t("span", {})
  ] });
}), zt = h(function({ label: e, value: n, icon: a, tone: r = "gold", className: s, ...o }, c) {
  return /* @__PURE__ */ u(
    "span",
    {
      ref: c,
      className: d(M.balance, r === "income" && M.balanceIncome, s),
      ...o,
      children: [
        a,
        e ? /* @__PURE__ */ t("span", { className: M.balanceLabel, children: e }) : null,
        /* @__PURE__ */ t("strong", { children: n })
      ]
    }
  );
}), qt = h(function({ className: e, ...n }, a) {
  return /* @__PURE__ */ t("div", { ref: a, className: d(M.actions, e), ...n });
}), Ca = "alpha-card-Cb1o4", Ba = "alpha-interactive-B8Tah", Ia = "alpha-gold-6-8E6", La = "alpha-icon-jzes9", Aa = "alpha-title-mSgoo", Oa = "alpha-body-W441Z", Fa = "alpha-padNone--1JEm", Wa = "alpha-padSm-zmolL", G = {
  card: Ca,
  interactive: Ba,
  gold: Ia,
  icon: La,
  title: Aa,
  body: Oa,
  padNone: Fa,
  padSm: Wa
}, Dt = h(function({ title: e, icon: n, variant: a = "default", hoverable: r = !0, padding: s = "default", className: o, children: c, ...i }, p) {
  return /* @__PURE__ */ u(
    "div",
    {
      ref: p,
      className: d(
        G.card,
        a === "gold" && G.gold,
        r && G.interactive,
        s === "sm" && G.padSm,
        s === "none" && G.padNone,
        o
      ),
      ...i,
      children: [
        n ? /* @__PURE__ */ t("div", { className: G.icon, children: n }) : null,
        e ? /* @__PURE__ */ t("h3", { className: G.title, children: e }) : null,
        c
      ]
    }
  );
}), jt = h(function({ className: e, ...n }, a) {
  return /* @__PURE__ */ t("div", { ref: a, className: d(G.body, e), ...n });
}), Pa = "alpha-grid-D2NDa", Ea = "alpha-card-dZtiA", Ma = "alpha-head-LP11E", Ra = "alpha-label-7x2Ut", Ua = "alpha-value-EpcEa", Ga = "alpha-sub-bBDn2", za = "alpha-icon-1cpgd", z = {
  grid: Pa,
  card: Ea,
  head: Ma,
  label: Ra,
  value: Ua,
  sub: Ga,
  icon: za
}, Yt = h(function({ label: e, value: n, sub: a, icon: r, className: s, children: o, ...c }, i) {
  return /* @__PURE__ */ u("div", { ref: i, className: d(z.card, s), ...c, children: [
    /* @__PURE__ */ u("div", { className: z.head, children: [
      /* @__PURE__ */ u("div", { children: [
        /* @__PURE__ */ t("div", { className: z.label, children: e }),
        /* @__PURE__ */ t("div", { className: z.value, children: n }),
        a ? /* @__PURE__ */ t("div", { className: z.sub, children: a }) : null
      ] }),
      r ? /* @__PURE__ */ t("span", { className: z.icon, children: r }) : null
    ] }),
    o
  ] });
}), Ht = h(function({ className: e, ...n }, a) {
  return /* @__PURE__ */ t("div", { ref: a, className: d(z.grid, e), ...n });
}), qa = "alpha-page-hj06n", Da = "alpha-card-BFyzf", ja = "alpha-glass-ZiyYx", Ya = "alpha-logo-q0YTM", Ha = "alpha-logoTitle-544eW", Xa = "alpha-logoSubtitle-7pPJh", Ka = "alpha-footer-R-0gN", Va = "alpha-divider-LrKjm", Qa = "alpha-orb-q1FnV", Za = "alpha-orbOne-hWE6a", Ja = "alpha-orbTwo-SQ0xT", A = {
  page: qa,
  card: Da,
  glass: ja,
  logo: Ya,
  logoTitle: Ha,
  logoSubtitle: Xa,
  footer: Ka,
  divider: Va,
  orb: Qa,
  orbOne: Za,
  orbTwo: Ja
}, Xt = h(function({ orbs: e = !1, className: n, children: a, ...r }, s) {
  return /* @__PURE__ */ u("div", { ref: s, className: d(A.page, n), ...r, children: [
    e ? /* @__PURE__ */ u(be, { children: [
      /* @__PURE__ */ t("span", { className: d(A.orb, A.orbOne), "aria-hidden": !0 }),
      /* @__PURE__ */ t("span", { className: d(A.orb, A.orbTwo), "aria-hidden": !0 })
    ] }) : null,
    a
  ] });
}), Kt = h(function({ variant: e = "solid", logoSrc: n, title: a, subtitle: r, footer: s, className: o, children: c, ...i }, p) {
  return /* @__PURE__ */ u("div", { ref: p, className: d(A.card, e === "glass" && A.glass, o), ...i, children: [
    n || a || r ? /* @__PURE__ */ u("div", { className: A.logo, children: [
      n ? /* @__PURE__ */ t("img", { src: n, alt: "" }) : null,
      a ? /* @__PURE__ */ t("h2", { className: A.logoTitle, children: a }) : null,
      r ? /* @__PURE__ */ t("div", { className: A.logoSubtitle, children: r }) : null
    ] }) : null,
    c,
    s ? /* @__PURE__ */ t("div", { className: A.footer, children: s }) : null
  ] });
}), Vt = h(function({ className: e, ...n }, a) {
  return /* @__PURE__ */ t("hr", { ref: a, className: d(A.divider, e), ...n });
}), _a = "alpha-tableCard-Fd1so", en = "alpha-header-5ZCAk", an = "alpha-headerTitle-1n62S", nn = "alpha-headerMeta-JwqY5", tn = "alpha-wrap-kwBb7", ln = "alpha-table-Dkosn", rn = "alpha-alignRight-9hY0G", sn = "alpha-alignCenter-YiUQy", on = "alpha-wrapText-wB-KM", cn = "alpha-empty-O1nyD", P = {
  tableCard: _a,
  header: en,
  headerTitle: an,
  headerMeta: nn,
  wrap: tn,
  table: ln,
  alignRight: rn,
  alignCenter: sn,
  wrapText: on,
  empty: cn
}, Qt = h(function({ className: e, ...n }, a) {
  return /* @__PURE__ */ t("div", { ref: a, className: d(P.tableCard, e), ...n });
}), Zt = h(function({ title: e, actions: n, meta: a, className: r, children: s, ...o }, c) {
  return /* @__PURE__ */ u("div", { ref: c, className: d(P.header, r), ...o, children: [
    e ? /* @__PURE__ */ t("h3", { className: P.headerTitle, children: e }) : null,
    s,
    a || n ? /* @__PURE__ */ u("div", { className: P.headerMeta, children: [
      a ? /* @__PURE__ */ t("span", { children: a }) : null,
      n
    ] }) : null
  ] });
}), Jt = h(function({ className: e, ...n }, a) {
  return /* @__PURE__ */ t("div", { ref: a, className: d(P.wrap, e), ...n });
}), _t = h(function({ className: e, ...n }, a) {
  return /* @__PURE__ */ t("table", { ref: a, className: d(P.table, e), ...n });
});
function he(l) {
  if (l === "right") return P.alignRight;
  if (l === "center") return P.alignCenter;
}
const el = h(function({ align: e, className: n, ...a }, r) {
  return /* @__PURE__ */ t("th", { ref: r, className: d(he(e), n), ...a });
}), al = h(function({ align: e, wrap: n, className: a, ...r }, s) {
  return /* @__PURE__ */ t("td", { ref: s, className: d(he(e), n && P.wrapText, a), ...r });
});
function nl({ colSpan: l, children: e = "No records found.", className: n, ...a }) {
  return /* @__PURE__ */ t("tr", { children: /* @__PURE__ */ t("td", { colSpan: l, className: d(P.empty, n), ...a, children: e }) });
}
const dn = "alpha-group-HE8-Z", un = "alpha-label-eeQ-m", pn = "alpha-required-V5rxn", hn = "alpha-hint-zlyRg", mn = "alpha-error-tGSoc", fn = "alpha-control-SeA--", gn = "alpha-invalid-2x0TI", bn = "alpha-select-dqkf5", vn = "alpha-textarea-0Ms--", yn = "alpha-affixWrap-mWsDL", Nn = "alpha-hasPrefix-1U1l4", wn = "alpha-hasSuffix-5FWin", Tn = "alpha-prefix-uMC1C", Sn = "alpha-suffix-sdTiz", k = {
  group: dn,
  label: un,
  required: pn,
  hint: hn,
  error: mn,
  control: fn,
  invalid: gn,
  select: bn,
  textarea: vn,
  affixWrap: yn,
  hasPrefix: Nn,
  hasSuffix: wn,
  prefix: Tn,
  suffix: Sn
}, tl = h(function({ label: e, required: n, hint: a, error: r, htmlFor: s, className: o, children: c, ...i }, p) {
  const g = ne(), N = s ?? g, w = `${N}-msg`, y = r || a ? w : void 0;
  return /* @__PURE__ */ u("div", { ref: p, className: d(k.group, o), ...i, children: [
    e ? /* @__PURE__ */ u("label", { className: k.label, htmlFor: N, children: [
      e,
      n ? /* @__PURE__ */ t("span", { className: k.required, children: "*" }) : null
    ] }) : null,
    typeof c == "function" ? c({ id: N, describedBy: y, invalid: !!r }) : c,
    r ? /* @__PURE__ */ t("div", { id: w, className: k.error, role: "alert", children: r }) : a ? /* @__PURE__ */ t("div", { id: w, className: k.hint, children: a }) : null
  ] });
}), ll = h(function({ className: e, ...n }, a) {
  return /* @__PURE__ */ t("label", { ref: a, className: d(k.label, e), ...n });
}), $n = h(function({ invalid: e, prefix: n, suffix: a, className: r, ...s }, o) {
  const c = /* @__PURE__ */ t(
    "input",
    {
      ref: o,
      className: d(k.control, e && k.invalid, r),
      "aria-invalid": e || void 0,
      ...s
    }
  );
  return !n && !a ? c : /* @__PURE__ */ u("div", { className: d(k.affixWrap, n && k.hasPrefix, a && k.hasSuffix), children: [
    n ? /* @__PURE__ */ t("span", { className: k.prefix, children: n }) : null,
    c,
    a ? /* @__PURE__ */ t("span", { className: k.suffix, children: a }) : null
  ] });
}), rl = $n, sl = h(function({ invalid: e, options: n, placeholder: a, className: r, children: s, ...o }, c) {
  return /* @__PURE__ */ u(
    "select",
    {
      ref: c,
      className: d(k.control, k.select, e && k.invalid, r),
      "aria-invalid": e || void 0,
      ...o,
      children: [
        a ? /* @__PURE__ */ t("option", { value: "", disabled: !0, children: a }) : null,
        n ? n.map((i) => /* @__PURE__ */ t("option", { value: i.value, disabled: i.disabled, children: i.label }, String(i.value))) : null,
        s
      ]
    }
  );
}), ol = h(function({ invalid: e, className: n, ...a }, r) {
  return /* @__PURE__ */ t(
    "textarea",
    {
      ref: r,
      className: d(k.control, k.textarea, e && k.invalid, n),
      "aria-invalid": e || void 0,
      ...a
    }
  );
}), kn = "alpha-wrap-oWUEj", xn = "alpha-cell-nJSWu", Cn = "alpha-invalid-NbReE", J = {
  wrap: kn,
  cell: xn,
  invalid: Cn
};
function cl({
  length: l = 6,
  value: e,
  defaultValue: n = "",
  onChange: a,
  onComplete: r,
  disabled: s,
  invalid: o,
  autoFocus: c,
  name: i,
  className: p,
  "aria-label": g = "One-time code"
}) {
  const N = e !== void 0, [w, y] = j(() => n.slice(0, l)), m = (N ? e : w) ?? "", T = m.slice(0, l).split(""), b = D([]), B = D(!1), $ = V(
    (f) => {
      const v = f.slice(0, l);
      N || y(v), a == null || a(v);
    },
    [N, l, a]
  );
  Y(() => {
    m.length === l && !B.current ? (B.current = !0, r == null || r(m)) : m.length < l && (B.current = !1);
  }, [m, l, r]), Y(() => {
    var f;
    c && ((f = b.current[0]) == null || f.focus());
  }, [c]);
  const C = (f, v) => {
    const x = m.padEnd(l, " ").split("");
    return x[f] = v || " ", x.join("").replace(/ +$/, "");
  }, L = (f) => (v) => {
    var E, X;
    const x = v.target.value.replace(/\D/g, "");
    if (!x) {
      $(C(f, ""));
      return;
    }
    if (x.length > 1) {
      const te = m.padEnd(l, " ").split("");
      for (let K = 0; K < x.length && f + K < l; K += 1)
        te[f + K] = x[K];
      $(te.join("").replace(/ +$/, "")), (E = b.current[Math.min(f + x.length, l - 1)]) == null || E.focus();
      return;
    }
    $(C(f, x)), f < l - 1 && ((X = b.current[f + 1]) == null || X.focus());
  }, O = (f) => (v) => {
    var x, E, X;
    if (v.key === "Backspace") {
      !T[f] && f > 0 ? (v.preventDefault(), $(C(f - 1, "")), (x = b.current[f - 1]) == null || x.focus()) : $(C(f, ""));
      return;
    }
    v.key === "ArrowLeft" && f > 0 && (v.preventDefault(), (E = b.current[f - 1]) == null || E.focus()), v.key === "ArrowRight" && f < l - 1 && (v.preventDefault(), (X = b.current[f + 1]) == null || X.focus());
  }, R = (f) => {
    var x;
    const v = f.clipboardData.getData("text").replace(/\D/g, "").slice(0, l);
    v && (f.preventDefault(), $(v), (x = b.current[Math.min(v.length, l - 1)]) == null || x.focus());
  };
  return /* @__PURE__ */ u("div", { className: d(J.wrap, p), role: "group", "aria-label": g, children: [
    Array.from({ length: l }, (f, v) => {
      var x;
      return /* @__PURE__ */ t(
        "input",
        {
          ref: (E) => {
            b.current[v] = E;
          },
          className: d(J.cell, o && J.invalid),
          type: "text",
          inputMode: "numeric",
          autoComplete: v === 0 ? "one-time-code" : "off",
          maxLength: 1,
          disabled: s,
          "aria-invalid": o || void 0,
          "aria-label": `Digit ${v + 1}`,
          value: ((x = T[v]) == null ? void 0 : x.trim()) ?? "",
          onChange: L(v),
          onKeyDown: O(v),
          onPaste: R,
          onFocus: (E) => E.currentTarget.select()
        },
        v
      );
    }),
    i ? /* @__PURE__ */ t("input", { type: "hidden", name: i, value: m.trim() }) : null
  ] });
}
const Bn = "alpha-spinner-GpFZS", In = "alpha-center-vBG4b", me = {
  spinner: Bn,
  center: In
}, fe = h(function({ size: e = 22, thickness: n = 3, label: a, className: r, style: s, ...o }, c) {
  return /* @__PURE__ */ t(
    "span",
    {
      ref: c,
      role: a ? "status" : void 0,
      "aria-label": a,
      "aria-hidden": a ? void 0 : !0,
      className: d(me.spinner, r),
      style: { width: e, height: e, borderWidth: n, ...s },
      ...o
    }
  );
});
function il({ className: l, ...e }) {
  return /* @__PURE__ */ t("div", { className: d(me.center, l), children: /* @__PURE__ */ t(fe, { label: "Loading", ...e }) });
}
const Ln = "alpha-btn-Fx11X", An = "alpha-gold-kqedE", On = "alpha-outlineGold-OufUS", Fn = "alpha-danger-V4fX8", Wn = "alpha-success-w6qB6", Pn = "alpha-ghost-1KINV", En = "alpha-sm-NhG0g", Mn = "alpha-lg-2plQf", Rn = "alpha-block-bnWJO", Un = "alpha-loader-X-9u-", W = {
  btn: Ln,
  gold: An,
  outlineGold: On,
  danger: Fn,
  success: Wn,
  ghost: Pn,
  sm: En,
  lg: Mn,
  block: Rn,
  loader: Un
}, Gn = {
  gold: W.gold,
  "outline-gold": W.outlineGold,
  danger: W.danger,
  success: W.success,
  ghost: W.ghost
}, le = h(function({
  as: e,
  variant: n = "gold",
  size: a = "md",
  block: r,
  loading: s,
  leftIcon: o,
  rightIcon: c,
  className: i,
  children: p,
  ...g
}, N) {
  const w = e ?? "button", y = w === "button", m = !!g.disabled || !!s;
  return /* @__PURE__ */ u(
    w,
    {
      ref: N,
      className: d(
        W.btn,
        Gn[n],
        a === "sm" && W.sm,
        a === "lg" && W.lg,
        r && W.block,
        i
      ),
      ...g,
      ...y ? { type: g.type ?? "button", disabled: m } : {},
      "aria-disabled": !y && m ? !0 : void 0,
      "aria-busy": s || void 0,
      children: [
        s ? /* @__PURE__ */ t("span", { className: W.loader, children: /* @__PURE__ */ t(fe, { size: 14 }) }) : o,
        p,
        c
      ]
    }
  );
}), zn = "alpha-chip-0nys-", qn = "alpha-interactive-TAT9X", Dn = "alpha-success-fK--U", jn = "alpha-danger-4agwh", Yn = "alpha-warning-2C34E", Hn = "alpha-info-0jRN4", Xn = "alpha-gold-OVrAO", Kn = "alpha-neutral-Av3JZ", Vn = "alpha-sm-dsdYB", Qn = "alpha-lg-elR6T", Zn = "alpha-dot--BrvN", I = {
  chip: zn,
  interactive: qn,
  success: Dn,
  danger: jn,
  warning: Yn,
  info: Hn,
  gold: Xn,
  neutral: Kn,
  sm: Vn,
  lg: Qn,
  dot: Zn
}, ge = {
  success: I.success,
  danger: I.danger,
  warning: I.warning,
  info: I.info,
  gold: I.gold,
  neutral: I.neutral
}, dl = h(function({ as: e, tone: n = "neutral", size: a = "md", dot: r, className: s, children: o, ...c }, i) {
  const p = e ?? "span", g = p === "button" || p === "a" || !!c.onClick;
  return /* @__PURE__ */ u(
    p,
    {
      ref: i,
      className: d(
        I.chip,
        ge[n],
        g && I.interactive,
        a === "sm" && I.sm,
        a === "lg" && I.lg,
        s
      ),
      ...p === "button" ? { type: c.type ?? "button" } : {},
      ...c,
      children: [
        r ? /* @__PURE__ */ t("span", { className: I.dot, "aria-hidden": !0 }) : null,
        o
      ]
    }
  );
});
function ul(l = "neutral", e = "md") {
  return d(I.chip, ge[l], e === "sm" && I.sm, e === "lg" && I.lg);
}
const Jn = "alpha-alert-7cYyI", _n = "alpha-fading-Ew8pQ", et = "alpha-icon-Zg6SB", at = "alpha-body-B60Rk", nt = "alpha-title-abGgF", tt = "alpha-close-narep", lt = "alpha-danger-CiZkW", rt = "alpha-success-1bzoB", st = "alpha-warning-q-j1Q", ot = "alpha-info-9r3r1", F = {
  alert: Jn,
  fading: _n,
  icon: et,
  body: at,
  title: nt,
  close: tt,
  danger: lt,
  success: rt,
  warning: st,
  info: ot
}, ct = {
  danger: F.danger,
  success: F.success,
  warning: F.warning,
  info: F.info
}, it = {
  danger: /* @__PURE__ */ t(Te, { size: 16 }),
  success: /* @__PURE__ */ t(we, { size: 16 }),
  warning: /* @__PURE__ */ t(Ne, { size: 16 }),
  info: /* @__PURE__ */ t(ye, { size: 16 })
}, pl = h(function({
  tone: e = "info",
  title: n,
  icon: a,
  dismissible: r = !1,
  autoDismissAfter: s = 5e3,
  fadeDuration: o = 500,
  onDismiss: c,
  className: i,
  children: p,
  ...g
}, N) {
  const [w, y] = j(!1), [m, T] = j(!1), b = D(c);
  b.current = c, Y(() => {
    if (s == null) return;
    const C = window.setTimeout(() => y(!0), s), L = window.setTimeout(() => {
      var O;
      T(!0), (O = b.current) == null || O.call(b);
    }, s + o);
    return () => {
      window.clearTimeout(C), window.clearTimeout(L);
    };
  }, [s, o]);
  const B = () => {
    y(!0), window.setTimeout(() => {
      var C;
      T(!0), (C = b.current) == null || C.call(b);
    }, o);
  };
  if (m) return null;
  const $ = a === !1 ? null : a ?? it[e];
  return /* @__PURE__ */ u(
    "div",
    {
      ref: N,
      role: e === "danger" ? "alert" : "status",
      className: d(F.alert, ct[e], w && F.fading, i),
      style: { transitionDuration: `${o}ms` },
      ...g,
      children: [
        $ ? /* @__PURE__ */ t("span", { className: F.icon, children: $ }) : null,
        /* @__PURE__ */ u("div", { className: F.body, children: [
          n ? /* @__PURE__ */ t("div", { className: F.title, children: n }) : null,
          p
        ] }),
        r ? /* @__PURE__ */ t("button", { type: "button", className: F.close, "aria-label": "Dismiss", onClick: B, children: /* @__PURE__ */ t(se, { size: 15 }) }) : null
      ]
    }
  );
}), dt = "alpha-backdrop-GVUh4", ut = "alpha-box-yfy7h", pt = "alpha-sm-K5k3W", ht = "alpha-lg-BgB1a", mt = "alpha-header-ILG9i", ft = "alpha-title-A5OeE", gt = "alpha-close--ER1C", bt = "alpha-footer-rro2w", U = {
  backdrop: dt,
  box: ut,
  sm: pt,
  lg: ht,
  header: mt,
  title: ft,
  close: gt,
  footer: bt
};
function hl({
  open: l,
  onClose: e,
  title: n,
  children: a,
  footer: r,
  size: s = "md",
  closeOnBackdrop: o = !0,
  closeOnEscape: c = !0,
  hideCloseButton: i = !1,
  className: p,
  container: g
}) {
  const N = D(null), w = D(null), y = D(e);
  y.current = e, Y(() => {
    var B;
    if (!l || typeof document > "u") return;
    w.current = document.activeElement;
    const T = document.body.style.overflow;
    document.body.style.overflow = "hidden", (B = N.current) == null || B.focus();
    const b = ($) => {
      c && $.key === "Escape" && y.current();
    };
    return document.addEventListener("keydown", b), () => {
      var $, C;
      document.removeEventListener("keydown", b), document.body.style.overflow = T, (C = ($ = w.current) == null ? void 0 : $.focus) == null || C.call($);
    };
  }, [l, c]);
  const m = V(
    (T) => {
      o && T.target === T.currentTarget && e();
    },
    [o, e]
  );
  return !l || typeof document > "u" ? null : Ge(
    /* @__PURE__ */ t("div", { className: U.backdrop, onMouseDown: m, children: /* @__PURE__ */ u(
      "div",
      {
        ref: N,
        role: "dialog",
        "aria-modal": "true",
        tabIndex: -1,
        className: d(U.box, s === "sm" && U.sm, s === "lg" && U.lg, p),
        children: [
          n || !i ? /* @__PURE__ */ u("div", { className: U.header, children: [
            n ? /* @__PURE__ */ t("h3", { className: U.title, children: n }) : /* @__PURE__ */ t("span", {}),
            i ? null : /* @__PURE__ */ t("button", { type: "button", className: U.close, "aria-label": "Close", onClick: e, children: /* @__PURE__ */ t(se, { size: 18 }) })
          ] }) : null,
          a,
          r ? /* @__PURE__ */ t("div", { className: U.footer, children: r }) : null
        ]
      }
    ) }),
    g ?? document.body
  );
}
const vt = "alpha-bar-XYoub", yt = "alpha-fill-6W-EK", Nt = "alpha-meta-uK4ai", wt = "alpha-metaValue-OAHpu", Q = {
  bar: vt,
  fill: yt,
  meta: Nt,
  metaValue: wt
}, ml = h(function({ value: e, max: n = 100, label: a, valueLabel: r, className: s, ...o }, c) {
  const i = n <= 0 ? 100 : n, p = Math.max(0, Math.min(100, e / i * 100));
  return /* @__PURE__ */ u("div", { ref: c, className: s, ...o, children: [
    a || r ? /* @__PURE__ */ u("div", { className: Q.meta, children: [
      /* @__PURE__ */ t("span", { children: a }),
      /* @__PURE__ */ t("span", { className: Q.metaValue, children: r === !0 ? `${Math.round(p)}%` : r })
    ] }) : null,
    /* @__PURE__ */ t(
      "div",
      {
        className: Q.bar,
        role: "progressbar",
        "aria-valuenow": e,
        "aria-valuemin": 0,
        "aria-valuemax": i,
        children: /* @__PURE__ */ t("div", { className: Q.fill, style: { width: `${p}%` } })
      }
    )
  ] });
});
function fl({
  target: l,
  prefix: e = "",
  suffix: n = "",
  duration: a = 1200,
  tick: r = 16,
  locale: s,
  animate: o = !0,
  ...c
}) {
  const [i, p] = j(() => o ? 0 : l);
  Y(() => {
    var m;
    if (!o || !Number.isFinite(l)) {
      p(l);
      return;
    }
    if (typeof window < "u" && ((m = window.matchMedia) != null && m.call(window, "(prefers-reduced-motion: reduce)").matches)) {
      p(l);
      return;
    }
    const N = l / (a / r);
    let w = 0;
    p(0);
    const y = window.setInterval(() => {
      w = Math.min(w + N, l), p(w), w >= l && window.clearInterval(y);
    }, r);
    return () => window.clearInterval(y);
  }, [l, a, r, o]);
  const g = Number.isInteger(l) ? Math.round(i).toLocaleString(s) : i.toFixed(2);
  return /* @__PURE__ */ t("span", { ...c, children: `${e}${g}${n}` });
}
const Tt = "alpha-header-AIWmk", St = "alpha-title-mv-ab", $t = "alpha-description-IaGTq", kt = "alpha-actions-6XyFL", xt = "alpha-breadcrumbs-ksUQl", Ct = "alpha-crumbCurrent-ognpl", Bt = "alpha-tabs-NMQM3", q = {
  header: Tt,
  title: St,
  description: $t,
  actions: kt,
  breadcrumbs: xt,
  crumbCurrent: Ct,
  tabs: Bt
}, gl = h(function({ title: e, description: n, actions: a, breadcrumbs: r, className: s, children: o, ...c }, i) {
  return /* @__PURE__ */ u("div", { ref: i, className: d(q.header, s), ...c, children: [
    /* @__PURE__ */ u("div", { children: [
      r != null && r.length ? /* @__PURE__ */ t("ol", { className: q.breadcrumbs, children: r.map((p, g) => /* @__PURE__ */ u(ve, { children: [
        g > 0 ? /* @__PURE__ */ t(oe, { size: 12, "aria-hidden": !0 }) : null,
        /* @__PURE__ */ t("li", { className: g === r.length - 1 ? q.crumbCurrent : void 0, children: p.href ? /* @__PURE__ */ t("a", { href: p.href, children: p.label }) : p.label })
      ] }, g)) }) : null,
      /* @__PURE__ */ t("h2", { className: q.title, children: e }),
      n ? /* @__PURE__ */ t("div", { className: q.description, children: n }) : null,
      o
    ] }),
    a ? /* @__PURE__ */ t("div", { className: q.actions, children: a }) : null
  ] });
}), bl = h(function({ className: e, ...n }, a) {
  return /* @__PURE__ */ t("div", { ref: a, className: d(q.tabs, e), ...n });
});
function vl({ title: l, description: e, action: n, tone: a = "muted" }) {
  return /* @__PURE__ */ u(
    "div",
    {
      style: {
        padding: "3rem 2rem",
        textAlign: "center",
        color: a === "danger" ? "var(--danger)" : "var(--text-muted)"
      },
      children: [
        /* @__PURE__ */ t("p", { style: { fontSize: "1.1rem", fontWeight: 600, marginBottom: 6 }, children: l }),
        e ? /* @__PURE__ */ t("p", { style: { fontSize: "0.9rem" }, children: e }) : null,
        n ? /* @__PURE__ */ t("div", { style: { marginTop: "1.25rem" }, children: n }) : null
      ]
    }
  );
}
function yl({ page: l, lastPage: e, total: n, onChange: a }) {
  return /* @__PURE__ */ u(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "1rem",
        padding: "1rem 1.5rem",
        borderTop: "1px solid var(--card-border)",
        fontSize: "0.85rem",
        color: "var(--text-muted)"
      },
      children: [
        /* @__PURE__ */ u("span", { children: [
          "Page ",
          l,
          " of ",
          e,
          " · ",
          n.toLocaleString("en-US"),
          " records"
        ] }),
        /* @__PURE__ */ u("span", { style: { display: "flex", gap: 8 }, children: [
          /* @__PURE__ */ t(le, { variant: "outline-gold", size: "sm", disabled: l <= 1, onClick: () => a(l - 1), children: "Previous" }),
          /* @__PURE__ */ t(le, { variant: "outline-gold", size: "sm", disabled: l >= e, onClick: () => a(l + 1), children: "Next" })
        ] })
      ]
    }
  );
}
const Nl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ArrowDownToLine: Se,
  ArrowUpFromLine: $e,
  Bell: ke,
  ChevronDown: re,
  ChevronRight: oe,
  Copy: xe,
  FileText: Ce,
  LayoutDashboard: Be,
  LifeBuoy: Ie,
  LogOut: Le,
  Network: Ae,
  Settings: Oe,
  ShieldCheck: Fe,
  Star: We,
  TrendingUp: Pe,
  Trophy: Ee,
  UserCircle: Me,
  Users: Re,
  Wallet: Ue
}, Symbol.toStringTag, { value: "Module" }));
export {
  pl as Alert,
  Kt as AuthCard,
  Xt as AuthPage,
  le as Button,
  Dt as Card,
  jt as CardBody,
  dl as Chip,
  fl as Counter,
  Vt as Divider,
  vl as EmptyState,
  bl as FilterTabs,
  rl as FormControl,
  tl as FormGroup,
  ll as FormLabel,
  xa as Hamburger,
  $n as Input,
  hl as Modal,
  Rt as NavGroup,
  Ut as NavItem,
  cl as OtpInput,
  gl as PageHeader,
  yl as Pagination,
  Ft as PanelLayout,
  ce as PanelLayoutContext,
  ml as ProgressBar,
  sl as Select,
  Wt as Sidebar,
  Pt as SidebarLogo,
  Mt as SidebarNav,
  Et as SidebarUser,
  fe as Spinner,
  il as SpinnerBlock,
  Yt as StatCard,
  Ht as StatCards,
  _t as Table,
  Qt as TableCard,
  nl as TableEmpty,
  Zt as TableHeader,
  Jt as TableWrap,
  al as Td,
  ol as Textarea,
  el as Th,
  Gt as Topbar,
  qt as TopbarActions,
  zt as TopbarBalance,
  ul as badgeClass,
  d as cx,
  Nl as icons,
  pe as navGroupStorageKey,
  ie as usePanelLayout
};
//# sourceMappingURL=index.js.map
